import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/public";

const get = () => {
    return httpUtils.post(SERVICE_NAME + "/getConstants");
}

const sendEmailResetPassword = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/sendEmailResetPassword", payload);
}

const constantApi = {
    get,
    sendEmailResetPassword
}

export default constantApi;